module.exports = __webpack_public_path__ + "img/loons_promo.af918e24.png";